import { supabase } from "@/integrations/supabase/client";

export interface Notification {
  id: string;
  user_id: string;
  type: 'bounty_deleted' | 'account_restricted' | 'refund_received' | 'system' | 'claim_accepted' | 'claim_rejected' | 'claim_request_received' | 'proof_submitted' | 'bounty_completed' | 'wall_featured' | 'withdrawal_approved' | 'withdrawal_rejected' | 'withdrawal_completed' | 'bounty_claimed' | 'new_message' | 'login_alert' | 'bounty_expiring';
  title: string;
  message: string;
  icon: string;
  details: any;
  is_read: boolean;
  created_at: string;
}

export const notificationService = {
  // Get user's notifications
  async getNotifications(limit: number = 20) {
    try {
      const { data, error } = await supabase
        .from('notifications')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(limit);

      if (error) throw error;
      return { data: data as Notification[], error: null };
    } catch (error) {
      return { data: null, error: error as Error };
    }
  },

  // Get unread count
  async getUnreadCount() {
    try {
      const { count, error } = await supabase
        .from('notifications')
        .select('*', { count: 'exact', head: true })
        .eq('is_read', false);

      if (error) throw error;
      return { count: count || 0, error: null };
    } catch (error) {
      return { count: 0, error: error as Error };
    }
  },

  // Mark notification as read
  async markAsRead(notificationId: string) {
    try {
      const { error } = await supabase
        .from('notifications')
        .update({ is_read: true })
        .eq('id', notificationId);

      if (error) throw error;
      return { error: null };
    } catch (error) {
      return { error: error as Error };
    }
  },

  // Mark all notifications as read
  async markAllAsRead() {
    try {
      const { error } = await supabase
        .from('notifications')
        .update({ is_read: true })
        .eq('is_read', false);

      if (error) throw error;
      return { error: null };
    } catch (error) {
      return { error: error as Error };
    }
  },

  // Delete notification
  async deleteNotification(notificationId: string) {
    try {
      // Return the deleted rows so a silently blocked delete (RLS denies
      // affect zero rows without an error) surfaces as a real failure.
      const { data, error } = await supabase
        .from('notifications')
        .delete()
        .eq('id', notificationId)
        .select('id');

      if (error) throw error;
      if (!data || data.length === 0) {
        throw new Error('Notification could not be deleted');
      }
      return { error: null };
    } catch (error) {
      return { error: error as Error };
    }
  }
};
